import { useSelector } from 'react-redux'
import { selectedHeaderTabSelector } from '../../app/selectors'

export function useSelectedTab() {
  return useSelector(selectedHeaderTabSelector)
}
